var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", { staticClass: "gray--text text--lighten-1" }, [
        _vm._v(_vm._s(_vm.label) + ": "),
      ]),
      _vm._v(" "),
      _vm.isInvoiceRejected && _vm.totalInvoiceErrors
        ? _c(
            "v-tooltip",
            { attrs: { "nudge-left": 0, bottom: "" } },
            [
              _c("template", { slot: "activator" }, [
                _c("div", { staticClass: "status-nf" }, [
                  _vm.invoiceStatusIcon
                    ? _c("img", {
                        staticClass: "mr-1",
                        attrs: {
                          src: require(`@/assets/images/icons/${_vm.invoiceStatusIcon}.svg`),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "red--text" }, [
                    _vm._v(_vm._s(_vm.invoiceStatus)),
                  ]),
                  _vm._v(" "),
                  _vm.totalInvoiceErrors > 1
                    ? _c(
                        "span",
                        { staticClass: "gray--text text--lighten-1" },
                        [
                          _c("small", { staticClass: "s-nf-plus-reason" }, [
                            _vm._v(
                              "(+ " + _vm._s(_vm.totalInvoiceErrors - 1) + ")"
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.refusalReasons, function (reason) {
                  return _c("p", { staticClass: "my-1" }, [
                    _vm._v("\n        " + _vm._s(reason) + "\n      "),
                  ])
                }),
                0
              ),
            ],
            2
          )
        : _c("div", { staticClass: "status-nf" }, [
            _vm.invoiceStatusIcon
              ? _c("img", {
                  staticClass: "mr-1",
                  attrs: {
                    src: require(`@/assets/images/icons/${_vm.invoiceStatusIcon}.svg`),
                  },
                })
              : _vm._e(),
            _vm._v("\n    " + _vm._s(_vm.invoiceStatus) + "\n  "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }